module.exports = __webpack_public_path__ + "img/logo4.65cc316a.svg";